import { Injectable } from '@angular/core';
import { Asegurado } from '../Models/asegurado-detalle';

@Injectable({
  providedIn: 'root',
})
export class FormDataService {
  asegurado: Asegurado;

  constructor() {
    this.asegurado = new Asegurado();
  }
}
